export class mdlRenewalPolicies {
    public PolicyNo: string;
    public ProductCode: string;
    public PolicyIssueDate: string;
    public PolicyFromDate: string;
    public PolicyToDate: string;
    public InsuredIdNo: string;
    public InsuredName: string;
    public InsuredMobileNo: string;
    public VehicleSequenceNo: string;
    public VehicleDefType: string;
    public VehicleCustomId: string;
    public VehiclePlateNo_En: string;
    public VehiclePlateNo_Ar: string;
    public VehicleModelYear: number;

}

export class mdlRenewalPoliciesListRes {
    public RegNo:number;
    public StatusCode: string;
    public StatusDesc: string;
    public RenewalPoliciesList: Array<mdlRenewalPolicies>=new Array<mdlRenewalPolicies>();

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlRenewalPolicies.ts